import React, {  useState, useEffect, useContext, useCallback} from 'react';
import { useDebouncedEffect } from '@/hooks/use-debounced-effect';
import DataContext from '@/contexts/DataContext';
import { useComponentLogger } from '@/lib/component-logger';
import { syncLastUsedParams } from '@/lib/dataHandlers/sync-last-used-params';

import { SelectDateText } from './select-date-text';


/**
 * A wrapper around SelectDateText to handle state changes and side effects in dynamic views
 * Currently used by ViewPage
 * We use state 'selectedViewParams' to track all the dropdown values. This is how each selector knows the values of the other selectors
 * @param {*} param
 */
export function SelectDateTextWrapper({config = {}}) {
    const logger = useComponentLogger('Select Date Text Wrapper');
    // const [selectedOption, setSelectedOption] = useState({value: null, dis: null, default: config?.default || null});
    const { viewParams, selectedViewParams, setSelectedViewParams, currentView, currentApp, setExternalURL } = useContext(DataContext);
    const [disabled, setDisabled] = useState(true);

    logger.debug('select param', config, viewParams, selectedViewParams, localStorage.getItem(`lastUsedParams-${currentView?.mobileAppRef?.val}`));

    const handleDisabledChange = useCallback((newDisabled) => {
        setDisabled(newDisabled);
    }, []);

    useEffect(() => {
        logger.debug('select config', config, selectedViewParams)
        // updateSelectedOption();
    }, []);
   
    /**
     * When a selected value changes,
     */
    useEffect(() => {
        logger.debug('select change', selectedViewParams, config.options)
        // updateSelectedOption();
    }, [selectedViewParams, config.options]);

    /**
     * Updates selectedViewParams when a new selection is made
     * Clears any child params this param may have
     * @param {*} event 
     */
    const handleSelect = (selectedOption) => {
        logger.debug('new select', selectedOption, selectedViewParams);
        let selectName = selectedOption.name;

        // if (selectData.value !== "range") {
            let newParams = {...selectedViewParams};
            
            newParams[selectName] = selectedOption

            // clear child params
            for (const param in newParams) {
                logger.debug('new param child', newParams[param], selectName);
                if (newParams[param].parentName && newParams[param].parentName === selectName) delete newParams[param];
            }

            setExternalURL(false);
           
            const appID = currentView?.mobileAppRef?.val;

            if (appID) syncLastUsedParams(`lastUsedParams-${appID}`, newParams);
            logger.debug('set selected: new select', newParams);
            setSelectedViewParams(newParams);
        // }
    }

    return <SelectDateText config={config} value={selectedViewParams[config?.name] ?? null} handleSelectParent={handleSelect} disabled={disabled} setDisabled={handleDisabledChange}/>    
    
}